import { ProtectedView } from '@moniebook-web/components/molecules/protected-view';
import { Outlet, type RouteObject } from 'react-router';

import { StyleScope } from '@/features/shared/style-scope';

const REGISTERS_PERMISSIONS = ['MANAGE_REGISTER'];

export const registersRoutes: RouteObject[] = [
    {
        path: '',
        element: <StyleScope name='registers-ui' />,
        children: [
            {
                path: 'onboarding',
                children: [
                    {
                        path: 'record-initial-sale',
                        async lazy() {
                            const { recordFirstSale } = await unwrapFeatures();
                            return recordFirstSale().then((m) => ({
                                Component: m.default,
                            }));
                        },
                    },
                ],
            },
            {
                path: 'registers',
                element: (
                    <ProtectedView accessCodeList={REGISTERS_PERMISSIONS}>
                        <Outlet />
                    </ProtectedView>
                ),
                children: [
                    {
                        path: '',
                        async lazy() {
                            const { registersList } = await unwrapFeatures();
                            return registersList().then((m) => ({
                                Component: m.default,
                            }));
                        },
                    },
                    {
                        path: ':id/edit',
                        async lazy() {
                            const { updateRegister } = await unwrapFeatures();
                            return updateRegister().then((m) => ({
                                Component: m.default,
                            }));
                        },
                    },
                    {
                        path: 'pair',
                        async lazy() {
                            const { pairRegister } = await unwrapFeatures();
                            return pairRegister().then((m) => ({
                                Component: m.default,
                            }));
                        },
                    },
                ],
            },
        ],
    },
];

async function unwrapFeatures() {
    const features = await import('registers/features');

    return features.default;
}
